import React from "react";
import { arrayOf, string } from "prop-types";
import ImageLink from "./ImageLink";

const PreloadImages = ({ imagesHref = [], host = "" }) => {
	return (
		<>
			{imagesHref.map(href => (
				<ImageLink href={host + href} key={href} />
			))}
		</>
	);
};

PreloadImages.propTypes = {
	host: string,
	imagesHref: arrayOf(string),
};

export default PreloadImages;
